import { ViewModel } from '../view-model';

export class ModelRunMitigationColumn implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Model Run Mitigation Column';
  readonly apiRoute: string;

  modelRunMitigationColumnId: string;
  orgTreeNodeModelRunId: string;
  headerText: string;
  mitigationColumnId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    if (!data) {
      return;
    }

    this.modelRunMitigationColumnId = data.modelRunMitigationColumnId;
    this.orgTreeNodeModelRunId = data.orgTreeNodeModelRunId;
    this.headerText = data.headerText;
    this.mitigationColumnId = data.mitigationColumnId;
  }
}
